import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { SLACK_OAUTH_URL } from "../../config";
import { focusRing } from "../ui/focusRing";

type SiteNavVariant = "home" | "inner";

interface SiteNavProps {
  variant: SiteNavVariant;
}

function SiteNav({ variant }: SiteNavProps) {
  if (variant === "inner") {
    return (
      <nav className="fixed w-full bg-white/80 backdrop-blur-sm z-50 border-b border-orange-200">
        <div className="max-w-5xl mx-auto px-6">
          <div className="flex justify-between h-16 items-center">
            <Link to="/" className={`flex items-center gap-2 ${focusRing}`}>
              <img src="/logo.webp" alt="Kyubot" className="w-8 h-8" />
              <span className="text-xl font-bold text-stone-800">Kyubot</span>
            </Link>
            <Link
              to="/"
              className={`flex items-center gap-2 text-sm font-medium text-stone-600 hover:text-brand-orange transition-colors ${focusRing}`}
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Home
            </Link>
          </div>
        </div>
      </nav>
    );
  }

  return (
    <nav className="fixed w-full bg-white/80 backdrop-blur-sm z-50 border-b border-orange-200">
      <div className="max-w-5xl mx-auto px-6">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center gap-2">
            <img src="/logo.webp" alt="Kyubot" className="w-8 h-8" />
            <span className="text-xl font-bold text-stone-800">Kyubot</span>
          </div>
          <div className="hidden md:flex items-center gap-6">
            <a
              href="#features"
              className={`text-sm text-stone-600 hover:text-brand-orange transition-colors ${focusRing}`}
            >
              Features
            </a>
            <a
              href="#pricing"
              className={`text-sm text-stone-600 hover:text-brand-orange transition-colors ${focusRing}`}
            >
              Pricing
            </a>
            <Link
              to="/docs"
              className={`text-sm text-stone-600 hover:text-brand-orange transition-colors ${focusRing}`}
            >
              Docs
            </Link>
            <a
              href={SLACK_OAUTH_URL}
              className={`bg-brand-orange text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-brand-orange-hover transition-colors shadow-sm ${focusRing}`}
            >
              Get Started
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default SiteNav;
